export default "__VITE_ASSET__BmIEV6UE__"